import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next/pages';
import { useAppSelector } from 'store';

import {
  getPassengersTotalAncillaryPrice,
  selectNumOfPassengers,
} from 'reducers/booking';

import { H3 } from '../Text';
import { SolidButton } from '../Button';
import CartFlights from 'components/CartFlights';
import CartPrices from 'components/CartPrices';
import BaseModal from './BaseModal';
import { useMemo } from 'react';
import { findKeyByRewriteUrl } from 'urlTranslations';
import { isRoundTripCart } from 'utils/cartRules';

interface Props {
  data: any;
  closeModal: () => void;
  modalOpen: boolean;
}

const CartModal: React.FC<Props> = ({ data, closeModal, modalOpen }) => {
  const router = useRouter();
  const state = useAppSelector(gState => ({
    totalPayment: gState.payment.totalPayment,
    numOfPassengers: selectNumOfPassengers(gState),
    paymentCurrency: gState.payment.paymentCurrency,
    passengers: gState.booking.passengers,
    tripType: gState.airfareSearch.tripType,
  }));
  const { t } = useTranslation();

  const sumOfAncillaries = useMemo(() => {
    return Object.values(
      getPassengersTotalAncillaryPrice(state.paymentCurrency, state.passengers),
    ).reduce((acc, curr) => acc + curr.value, 0);
  }, [state.passengers, state.paymentCurrency]);

  const priceAncillaries = useMemo(() => {
    return getPassengersTotalAncillaryPrice(
      state.paymentCurrency,
      state.passengers,
    );
  }, [state.passengers, state.paymentCurrency]);

  return (
    <BaseModal closeModal={closeModal} isCartModal modalOpen={modalOpen}>
      <H3 className="!text-lg leading-6 mb-2 font-medium text-gray-900">
        <b>{t('Cart')}</b>
      </H3>
      <div className="flex-col lg:flex-row sm:items-start jusitfy-center max-h-[30rem] h-full overflow-y-auto">
        <CartFlights
          backgroundColor="bg-tt-white-purple"
          flightDetails={data}
          isCartPackagesModal
          isCart
        />
        <div className="p-4">
          <CartPrices
            sumOfAncillaries={sumOfAncillaries}
            ancillaries={priceAncillaries}
            serviceFee={state.totalPayment.serviceFee}
            numOfPassengers={state.numOfPassengers}
            sumOfTickets={state.totalPayment.totalPayment}
            paymentCurrency={state.paymentCurrency}
            isRoundTrip={isRoundTripCart(
              router.query.tripType,
              state.tripType,
            )}
          />
        </div>
        <SolidButton
          className="h-1/2 self-center ml-auto mr-auto block"
          onClick={() =>
            router.push(findKeyByRewriteUrl('/cart/', router.locale))
          }>
          {t('Continue payment')}
        </SolidButton>
      </div>
    </BaseModal>
  );
};

export default CartModal;
